var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"overlay",class:_vm.overlay_class,style:(_vm.overlay_style)},[(_vm.show_default)?_vm._t("default"):_vm._t("overlay")],2)}
var staticRenderFns = []

export { render, staticRenderFns }